/**
 * How long a browser Supabase request may take before it is aborted (CAUSE-B F1).
 *
 * supabase-js runs auth calls inside an exclusive cross-tab lock, so an auth request on a dead socket must fail
 * fast to release it. Storage is exempt (uploads and downloads may legitimately run long), as is anything else
 * that is not auth or PostgREST (edge functions, realtime). Returns null for "no deadline".
 */
export const SUPABASE_AUTH_DEADLINE_MS = 10_000
export const SUPABASE_DATA_DEADLINE_MS = 20_000

export function supabaseRequestDeadlineMs(url: string): number | null {
  let path = url
  try {
    path = new URL(url).pathname
  } catch {
    // relative or unusual URL: match on the raw string
  }
  // Match the API root, never a storage object name containing an API path.
  if (/^\/auth\/v1(?:\/|$)/.test(path)) return SUPABASE_AUTH_DEADLINE_MS
  if (/^\/rest\/v1(?:\/|$)/.test(path)) return SUPABASE_DATA_DEADLINE_MS // tables, views and /rest/v1/rpc/*
  return null
}
